export default "__VITE_ASSET__DslI9Tl1__"